import { render } from "./signaturePopUp.vue?vue&type=template&id=0b9f06a6&scoped=true"
import script from "./signaturePopUp.vue?vue&type=script&lang=js"
export * from "./signaturePopUp.vue?vue&type=script&lang=js"

import "./signaturePopUp.vue?vue&type=style&index=0&id=0b9f06a6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9f06a6"]])

export default __exports__